export default ({
  pageState: { editorImportVisible }
}) => {
  return {
    editorImportVisible: !editorImportVisible
  }; 
};
